var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26565 1.39781C0.969883 1.7186 0.803755 2.15344 0.803755 2.60682C0.803755 3.0602 0.969883 3.49504 1.26565 3.81583L6.99356 10.0206L1.26565 16.2253C0.986667 16.5496 0.834788 16.9786 0.842007 17.4218C0.849226 17.865 1.01498 18.2879 1.30435 18.6014C1.59372 18.9149 1.98412 19.0944 2.39328 19.1022C2.80245 19.1101 3.19845 18.9455 3.49785 18.6433L10.3419 11.2296C10.6376 10.9088 10.8038 10.4739 10.8038 10.0206C10.8038 9.56718 10.6376 9.13234 10.3419 8.81155L3.49785 1.39781C3.20172 1.07742 2.80029 0.897461 2.38175 0.897461C1.96321 0.897461 1.56179 1.07742 1.26565 1.39781Z",
    fill: "#59B8CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.00f1b4b88b2fef193ae66b47e32f5a3a.svg";
export { ForwardRef as ReactComponent };